const BASE_URL = window.location.origin;
import { stringify } from "query-string";

interface ILoginParams {
  email: string;
  password: string;
}

type ITwoFactorParams = { code: string }

interface IResetPasswordParams {
  email: string;
}

interface ISSOLoginParams {
  team_name: string;
}

interface IUpdatePasswordParams {
  password: string;
  password_confirmation: string;
}

class Api {

  getHeaders (headers: {}): {} {
    return Object.assign({}, {
      'Content-Type': 'application/json',
    }, headers);
  }

  // handleResponse = (response) => {
  //   if (response.ok) return response.text().then((data) => {
  //     resolve(data ? JSON.parse(data) : {})
  //   });
  //   return response.text().then((error) => {
  //     error.code = response.status;
  //     throw error;
  //   });
  // }

  get = (path: string, params = {}, headers = {})  => (
    fetch(`${BASE_URL}${path}?${stringify(params || {})}`, {
      headers:  this.getHeaders(headers)
    }).then(response => {
      return response.text()
    })
    .then((data) => {
      return (data ? JSON.parse(data) : {})
    })
  )

  post =  (path: string, params = {}, headers = {})  => (
    fetch(`${BASE_URL}${path}`, {
      headers:  this.getHeaders(headers),
      method: 'POST',
      body: JSON.stringify(params),
    }).then(response => {
      return response.text()
    })
    .then((data) => {
      return (data ? JSON.parse(data) : {})
    })
  )

  put = (path: string, params = {}, headers = {})  => (
    fetch(`${BASE_URL}${path}`, {
      headers:  this.getHeaders(headers),
      method: 'PUT',
      body: JSON.stringify(params),
    }).then(response => {
      return response.text()
    })
    .then((data) => {
      return (data ? JSON.parse(data) : {})
    })
  )

  postLogin = (params: ILoginParams) => this.post(`/api/v4/login`, params)
  sendTwoFactor = () => this.post(`/api/v4/two_factor_auth/send_2fa_code`)
  postTwoFactor = (param: ITwoFactorParams) => this.get(`/api/v4/two_factor_auth/authorize`, param)
  postResetPassword = (params: IResetPasswordParams) => this.post(`/api/v4/reset_password`, params)
  postSSOLogin = (params: ISSOLoginParams) => this.post(`/api/v4/sso`, params)
  putUpdatePassword = (token: string, params: IUpdatePasswordParams) => this.put(`/api/v4/update_password/${token}`, params)
}

export default new Api();
